import { request } from './client'; 

export const logoService = {
  getLogos: () => request('/logos'), 

  getOrganisations: () => request('/organisations'), 
  
  uploadLogo: (file, name, ratio, organisationId) => {
    const formData = new FormData();
    formData.append('logo', file); 
    if (name) formData.append('name', name); 
    if (ratio) formData.append('ratio', ratio); 
    if (organisationId) formData.append('organisation_id', organisationId); // <-- Updated naming
    
    return request('/logos/upload-logo', { 
      method: 'POST',
      body: formData,
    });
  },

  deleteLogo: (id) => request(`/logos/${id}`, { method: 'DELETE' })
};

